import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetStaff, doUpdateStaff } from '../../../store/staff.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/campus/staff/Editor';
import { errorVariant, warningVariant } from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const CampusStaffEdit: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { staff, isLoading } = useSelector((state: RootState) => state.staff);

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  useEffect(() => {
    getStaff(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [])

  const getStaff = async (id: string) => {
    const res = await dispatch(doGetStaff(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: any) => {
    const res = await dispatch(doUpdateStaff(id, req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.edit'), {
          variant: 'success'
        });
        console.log('search', location.search);
        history.push(`/campus/staff${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), {
          variant: 'warning',
        });
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.campus')}
        currentMenu={t('campus.staff.title7')}
      />
      <Editor
        staff={staff || null}
        onSubmit={onSubmit}
      />
      <Footer />
    </div>
  )
}

export default CampusStaffEdit;
